import { createFileRoute } from "@tanstack/react-router";
import { LegalPage } from "@/components/legal/LegalPage";
import { CookiePolicy } from "@/components/legal/LegalModal";

export const Route = createFileRoute("/en/cookies")({
  head: () => ({
    meta: [
      { title: "Cookie policy — Sellavo" },
      { name: "description", content: "Which cookies Sellavo uses and how you control them." },
      { property: "og:title", content: "Cookie policy — Sellavo" },
      { property: "og:description", content: "Which cookies Sellavo uses and how you control them." },
      { property: "og:type", content: "website" },
      { name: "twitter:card", content: "summary" },
    ],
    links: [{ rel: "canonical", href: "https://sellavo.com/en/cookies" }],
  }),
  component: () => <LegalPage title="Cookie policy" intro="Which cookies Sellavo uses and how you control them."><CookiePolicy /></LegalPage>,
});
